import React, { PropTypes } from 'react';
import { FormattedMessage } from 'react-intl';
import cn from 'classnames';
import { Plus, Checkmark, Warning } from '@bibliocommons/base-icons';
import Capsule from '../Capsule';

import './FineStatusCapsule.scss';

const getIconForStatus = (status) => {
  switch (status) {
    case 'PAID':
      return <Checkmark color="currentColor" />;
    case 'ACCRUING':
      return <Warning />;
    case 'CREDIT':
      return <Plus />;
    default:
      return null;
  }
};

export default function FineStatusCapsule({ status }) {
  const formattedStatus = status && status.toLowerCase();

  const className = cn('cp-fine-status-capsule', formattedStatus);

  return (
    <Capsule className={className}>
      {getIconForStatus(status)} <FormattedMessage id={`fines_${formattedStatus}`} />
    </Capsule>
  );
}

FineStatusCapsule.propTypes = {
  status: PropTypes.string
};



// WEBPACK FOOTER //
// ./app/components/borrowing/fines/FineStatusCapsule/FineStatusCapsule.jsx